import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import { CategoryReviewState } from '../types/CategoryReview'

const mutations: MutationTree<CategoryReviewState> = {
  [types.SET_LIST] (state, { categoryId, items, total_count, average_rating, page, page_size }) {
    state.categoryId = categoryId
    state.items = items
    state.totalCount = total_count
    state.averageRating = average_rating
    state.currentPage = page
    state.pageSize = page_size || state.pageSize
  },
  [types.RESET] (state) {
    state.categoryId = null
    state.items = []
    state.totalCount = 0
    state.averageRating = 0
    state.currentPage = 1
  }
}

export default mutations
